interface SlackActivityToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  showLabel?: boolean;
}

export function SlackActivityToggle({
  checked,
  onChange,
  disabled = false,
  showLabel = true,
}: SlackActivityToggleProps) {
  return (
    <label
      className={`inline-flex items-center gap-2 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={(e) => e.stopPropagation()}
    >
      <span className="relative w-10 h-5 flex-shrink-0 inline-block">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={() => onChange()}
          className="opacity-0 w-0 h-0 absolute"
        />
        <span
          className={`absolute inset-0 rounded-full transition-colors ${checked ? 'bg-blue-600' : 'bg-gray-300'}`}
        />
        <span
          className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform ${checked ? 'translate-x-5' : ''}`}
        />
      </span>
      {showLabel && (
        <span className="text-sm text-gray-700">
          {checked ? 'On' : 'Off'}
        </span>
      )}
    </label>
  );
}
